import { render, staticRenderFns } from "./cModalSop.vue?vue&type=template&id=a74c4fb8"
import script from "./cModalSop.vue?vue&type=script&lang=js"
export * from "./cModalSop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports